module.exports = __webpack_public_path__ + "static/careers-graduates-6e890bc54ffd0823010ae3c3ad449246.jpg";